import React, {Component} from "react";
import {connect} from "react-redux";
import {Grid, Row, Col,} from "react-bootstrap";
import {Card} from "components/Card/Card.jsx";
import {withRouter} from "react-router-dom";
import {brandActions} from "../../../redux/actions/brand-actions";
import Select from "react-select";
import SimpleReactValidator from "simple-react-validator";
import CustomerBrandPermissions from "./CustomerBrandPermissions";
import {customSelectStyles} from "../../ThemeComponents/selectStyles";
import {helperFunctions as HF} from '../../../helper/helperFunctions';
import $ from 'jquery';

class CustomerPermission extends Component {
    constructor(props) {

        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            formData: {
                vendor_id: "",
                brand_id: "",
                customer_id: this.props.match.params.id
            },
            selectedBrands: []
        };
    }

    componentDidMount() {
        const {customer_id} = this.state.formData;
        this.props.getAllCustomerBrandsCall(customer_id);
    }

    getOptions() {
        if (this.props.brands == undefined) {
            return [];
        }
        return this.props.brands.map(({id, title}) => ({
            value: id,
            label: title
        }));
    }

    brandChangeHandler = event => {
        this.setState({
            formData: {
                ...this.state.formData,
                brand_id: event.id
            }
        });
    };

    vendorIdChangeHandler = e => {
        this.setState({
            formData: {
                ...this.state.formData,
                [e.target.name]: e.target.value
            }
        });
    };

    handleFormSubmit = e => {
        e.preventDefault();
        if (this.validator.allValid()) {
            const {formData} = this.state;
            this.props.storeCustomerbRrandCall(formData.brand_id, formData.customer_id, formData).then(res => {
                this.props.getAllCustomerBrandsCall(formData.customer_id);
                this.setState({
                    formData: {
                        ...this.state.formData,
                        vendor_id: "",
                        brand_id: ""
                    }
                }, () => {
                    this.validator.hideMessages();
                    $('.css-dvua67-singleValue').text('Select Brand');
                });
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    render() {
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col
                                                    md={12}
                                                    style={{
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    <h3>Manage Permissions</h3>
                                                </Col>

                                                <Col md={12}>
                                                    <form
                                                        onSubmit={
                                                            this
                                                                .handleFormSubmit
                                                        }
                                                    >
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="permissionList mt-xlg">
                                                                    <Select
                                                                        value={HF.returnTitleWithId(this.state.formData.brand_id, this.props.brands)}
                                                                        styles={
                                                                            customSelectStyles
                                                                        }
                                                                        getOptionLabel={(option) => option.title}
                                                                        getOptionValue={(option) => option.id}
                                                                        onChange={
                                                                            this
                                                                                .brandChangeHandler
                                                                        }
                                                                        options={this.props.brands}
                                                                        isSearchable={
                                                                            true
                                                                        }
                                                                        name={
                                                                            "brand_id"
                                                                        }
                                                                        isMulti={
                                                                            false
                                                                        }
                                                                        placeholder={
                                                                            "Select Brand"
                                                                        }
                                                                        isClearable={
                                                                            false
                                                                        }
                                                                    />
                                                                    {this.validator.message(
                                                                        "brand",
                                                                        this
                                                                            .state
                                                                            .formData
                                                                            .brand_id,
                                                                        "required"
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="permissionList mt-xlg">
                                                                    <input
                                                                        type="text"
                                                                        name="vendor_id"
                                                                        className="form-control"
                                                                        placeholder="External vendor Id/Ref No."
                                                                        onChange={
                                                                            this
                                                                                .vendorIdChangeHandler
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .formData
                                                                                .vendor_id
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 mb-xlg">
                                                                <div className="mt-xlg text-center">
                                                                    <input
                                                                        type="submit"
                                                                        value="Add Brand Access"
                                                                        className="customBtn btnBlue"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>

                                                    {
                                                        this.props.brandPermissions && this.props.brandPermissions.length > 0 &&
                                                        <CustomerBrandPermissions
                                                            brandPermissions={
                                                                this.props
                                                                    .brandPermissions.map(item => {
                                                                    return {...item, disabled: true}
                                                                })
                                                            }
                                                            customer_id={this.state.formData.customer_id}
                                                            fetchBrandAccess={this.props.getAllCustomerBrandsCall}
                                                        />
                                                    }
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllBrandsCall: () => {
            dispatch(brandActions.getAllBrands());
        },
        getAllCustomerBrandsCall: custId => {
            dispatch(brandActions.getAllCustomerBrands(custId));
        },
        storeCustomerbRrandCall: (brand_id, customer_id, data) => {
            return dispatch(brandActions.storeCustomerBrand(brand_id, customer_id, data));
        }
    };
};

const mapStateToProps = state => {
    const {brands, customerBrandPermissions} = state.brandReducer;
    return {
        brands: brands,
        brandPermissions: customerBrandPermissions
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CustomerPermission)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Customers/CustomerPermission.jsx